import React, { PropsWithChildren } from "react";
//#region types
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const WidgetTitle: React.FC<PropsWithChildren> = (props) => {
  return (
    <Grid container direction="column" className={cssExports.widgetTitle}>
      {props.children}
    </Grid>
  );
};

export default WidgetTitle;
